/**
 * https://stackoverflow.com/a/38554580
 */
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'isMinDate'})
export class IsMinDatePipe implements PipeTransform {

  constructor() {}

  transform(value, args: string[]): any {
    const theDate = moment(value);
    return theDate.isSame('0001-01-01', 'day');
  }
}
